import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Dropdown, DropdownItem, Typography } from 'fronton-react';
import { useSetRecoilState } from 'recoil';
import { activeRoomId } from 'pages/common/store/rooms';
import { roomTypes } from './const';
import { ButtonContainer, HeaderContainer, LayerContainer } from './styles';

export const RoomTypeField = () => {
  const { control } = useFormContext();
  const setSelectedRoomId = useSetRecoilState(activeRoomId);

  return (
    <>
      <ButtonContainer>
        <HeaderContainer>
          <Typography variant="h3" color="text-primary">
            Комната укладки
          </Typography>
        </HeaderContainer>
      </ButtonContainer>
      <LayerContainer>
        <Controller
          name="roomType"
          control={control}
          render={({ field: { onChange, value } }) => {
            const handleSelect = (selectedRoomType: string | null) => {
              onChange(selectedRoomType);
              if (selectedRoomType && selectedRoomType !== value) {
                setSelectedRoomId('');
              }
            };

            return (
              <div data-testid={`${value}-room-type-selected`}>
                <Dropdown closeOnSelect mobile={false} size="l" onSelect={handleSelect} value={value}>
                  {roomTypes.map(({ name, label, description }) => (
                    <div data-testid={`${name}-room-type`}>
                      <DropdownItem
                        key={name}
                        text={label}
                        value={name}
                        description={description}
                        selected={name === value}
                      />
                    </div>
                  ))}
                </Dropdown>
              </div>
            );
          }}
        />
      </LayerContainer>
    </>
  );
};
